import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { Transaction } from '../../models/transaction';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-posm-search',
  templateUrl: './posm-search.page.html',
  styleUrls: ['./posm-search.page.scss'],
})
export class PosmSearchPage implements OnInit {

  data = new Data();
  myId: any;
  user: any;
  model: Transaction[];
  dataSource: MatTableDataSource<Transaction>;

  displayedColumns: string[] = ['position', 'date', 'order', 'item', 'weight', 'amount', 'status'];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  searching = false;
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  ic = '';
  icx = '';
  trans: any;

  constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getCPCustomer',
      content: this.myId
    };

  }

  ngOnInit() {

    /*const ELEMENT_DATA: PeriodicElement[] = [
      {position: 1, name: 'Abc', weight: 1.0079, symbol: 'H'},
      {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
      {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
      {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
      {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
      {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
      {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
    ];*/

    

    /*this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    });*/
  }

  getRecord(row) {
    console.log(row);
    if(row.status === 'Verified' || row.status === 'PL9 Generated') this.router.navigate(['/members/posm-ordering/' + row.order]);
    else this.router.navigate(['/members/posm/' + row.position + '/0']);
  }

  getCust() {
    this.searching = false;

    var dt1 = {
      id: this.ic,
      icx: this.icx
    }

    this.data =  {
      id: 4,
      name: 'posTransactionHistory',
      content: dt1
    };

    console.log(this.data);

    this.apiService.postData(this.data).subscribe((response) => {

      this.searching = true;

      this.model = response.data;

      console.log(this.model);

      this.dataSource = new MatTableDataSource(this.model);

      /*this.user = response.data;
      this.data =  {
        id: 4,
        name: 'posTransactionHistory',
        content: {
          id : localStorage.getItem('user')
        }
      };

      this.apiService.postData(this.data).subscribe((response) => {

        this.model = response.data;

        console.log(this.model);

        this.dataSource = new MatTableDataSource(this.model);

        console.log(this.dataSource);
        this.dataSource.paginator = this.paginator;
      });*/


    });
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogFourteenPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  getLimit() {
    if (this.myId === '126') {
      return 12;
    } else {
      return 14;
    }
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogFourteenPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
